import React, { useEffect, useState } from 'react';
import img1 from '../../Assets/Images/img1.jpeg';
import img2 from '../../Assets/Images/img2.png';
import img3 from '../../Assets/Images/img3.jpeg';
import img4 from '../../Assets/Images/img4.jpeg';
import img5 from '../../Assets/Images/img5.jpeg';
import img6 from '../../Assets/Images/img6.png';
import img7 from '../../Assets/Images/img7.png';
import img8 from '../../Assets/Images/img8.jpeg';
import '../../Assets/CSS/ImageCarousel.css';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useNavigate, useParams } from 'react-router-dom';
import Login from '../auth/login/Login';
import { getCookie } from '../auth/login/GetCookie';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


// Array of image data
const imagesGroup1 = [
  { id: 1, src: img1, width: '546px', height: '263px' },
  { id: 2, src: img2, width: '268px', height: '263px' },
  { id: 3, src: img4, width: '546px', height: '263px' },
  { id: 4, src: img3, width: '268px', height: '263px' },
  { id: 5, src: img5, width: '268px', height: '268px' },
  { id: 6, src: img6, width: '546px', height: '263px' },
  { id: 7, src: img7, width: '268px', height: '263px' },
  { id: 8, src: img8, width: '268px', height: '263px' },
];


const SkeletonSlide = () => (
  <div className="ImageCarouselSwiper">
    <Skeleton
      width={268}
      height={263}
      borderRadius={20}
      style={{ margin: '0 auto' }}
    />
  </div>
);



const ImageCarousel = ({ isAuthenticated }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
     const navigate = useNavigate(); // React Router hook
      const [products, setProducts] = useState([]);
       const [product, setProduct] = useState([]);
      //  const [loading, setLoading] = useState(true);
       const [topProductsLoading, setTopProductsLoading] = useState(true);
  const [singleProductLoading, setSingleProductLoading] = useState(true);
       const [error, setError] = useState(null);
         const { productId } = useParams(); // Get productId from URL params

     
        const handleCloseLogin = () => {
        setShowLoginModal(false);
    }

  const handleImageClick = (clickedProductId) => {
     if (!isAuthenticated) {
            setShowLoginModal(true);
            return;
        }
       navigate(`/productdetail/${clickedProductId}`);
  };

    const fetchTopProducts = async () => {
      try {
        const token = getCookie("token");
      

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/top-per-seller`,

        );

        setProducts(response.data);
        console.log("product Banner : ",response.data)
      } catch (err) {
        setError(err.message);
      } finally {
         setTopProductsLoading(false);
      }
    };


    //      const fetchSingleProduct = async () => {
    //   try {
    //     const token = getCookie("token");
       

    //     const response = await axios.get(
    //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/${productId}`,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );

    //           setProduct(prev => [...prev, response.data]);
    //     console.log("Single product:", response.data);
    //   } catch (err) {
    //     setError(err.message);
    //   } finally {
    //      setSingleProductLoading(false);
    //   }
    // };

     useEffect(() => {
      
    
        fetchTopProducts();
        // fetchSingleProduct()
        setSingleProductLoading(false)
      }, []);

  

  if (topProductsLoading || singleProductLoading) {
    return (
      <div className="container-fluid px-4 pt-3 Image-carousel">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          loop={true}
          spaceBetween={10}
          centeredSlides={false}
          className="mySwiper"
          freeMode={true}
          allowTouchMove={false}
          speed={2000}
          breakpoints={{
            640: { slidesPerView: 3, spaceBetween: 8 },
            768: { slidesPerView: 3, spaceBetween: 8 },
            1024: { slidesPerView: 4, spaceBetween: 8 },
            1400: { slidesPerView: 5, spaceBetween: 8 },
          }}
        >
          {[...Array(5)].map((_, i) => (
            <SwiperSlide key={i}>
              <SkeletonSlide />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }

  if (error) return <div className="error-message">Error: {error}</div>;

        // Get only the first image for each product
    const productSlides = products.reduce((acc, product) => {
        if (product.productImageUrls && product.productImageUrls.length > 0) {
            const firstImage = product.productImageUrls[0];
            if (firstImage && firstImage !== "string") {
                acc.push({
                    url: firstImage,
                    productId: product.productId,
                    alt: `${product.productName} - Main Image`,
                    width: '268px', // Standard width
                    height: '263px' // Standard height
                });
            }
        }
        return acc;
    }, []);


  return (
    <div className="container-fluid px-4 pt-3 Image-carousel "
      >
          {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}
            {productSlides.length > 0 && (
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 0, disableOnInteraction: false }} 
        loop={true} // Enable continuous loop
        spaceBetween={10} // Space between slides
        centeredSlides={false} // Do not center the slides for a grid-like layout
        className="mySwiper"
        freeMode={true}
        allowTouchMove={false}
        speed={2000}

        breakpoints={{
          640: {
            slidesPerView: 3,
            spaceBetween: 8,
            centeredSlides: true,

          },
          768: {
            slidesPerView: 3, 
            spaceBetween: 8,
            centeredSlides: true,
          }, // 2 slides on medium screens
          1024: { slidesPerView: 4, spaceBetween: 8, }, // 4 slides on large screens
          1400: { slidesPerView: 5, spaceBetween: 8 }, // 5 slides on extra large screens
        }}
      >
        {/* Generate a separate SwiperSlide for each image */}
         {productSlides.map((slide, index) => (
          <SwiperSlide 
          // key={index} 
          key={`${slide.productId}-${index}`}
          className='ImageCarouselSwiper'
         
          >
        <img
              src={slide.url}
              alt={slide.alt}
              className="d-block w-100 object-fit-cover"
              style={{
                width:slide.width ,
                height: slide.height,
                borderRadius: '20px',
                cursor:'pointer'
                
              }}
               onClick={() => handleImageClick(slide.productId)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      )}
    </div>
  );
};

export default ImageCarousel;

